<template>
    <div class="w-full">
        <div class="relative flex flex-col">
            <div class="flex">
                <div class="input-wrapper grow">
                    <label class="text-xs">Search</label>
                    <div class="relative">
                        <div class="absolute mt-3 ml-2">
                            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.9 18.9746L10.325 12.3996C9.825 12.8329 9.24167 13.1704 8.575 13.4121C7.90833 13.6538 7.2 13.7746 6.45 13.7746C4.65 13.7746 3.125 13.1496 1.875 11.8996C0.625 10.6496 0 9.14128 0 7.37461C0 5.60794 0.625 4.09961 1.875 2.84961C3.125 1.59961 4.64167 0.974609 6.425 0.974609C8.19167 0.974609 9.69583 1.59961 10.9375 2.84961C12.1792 4.09961 12.8 5.60794 12.8 7.37461C12.8 8.09128 12.6833 8.78294 12.45 9.44961C12.2167 10.1163 11.8667 10.7413 11.4 11.3246L18 17.8746L16.9 18.9746ZM6.425 12.2746C7.775 12.2746 8.925 11.7954 9.875 10.8371C10.825 9.87878 11.3 8.72461 11.3 7.37461C11.3 6.02461 10.825 4.87044 9.875 3.91211C8.925 2.95378 7.775 2.47461 6.425 2.47461C5.05833 2.47461 3.89583 2.95378 2.9375 3.91211C1.97917 4.87044 1.5 6.02461 1.5 7.37461C1.5 8.72461 1.97917 9.87878 2.9375 10.8371C3.89583 11.7954 5.05833 12.2746 6.425 12.2746Z" fill="#878686"/>
                            </svg>
                        </div>
                        <input v-model="search" :placeholder="placeholder" class="block tracking-wider border-none rounded bg-gray-black w-full h-10 text-sm placeholder-theme-878686 pl-8" type="text">
                    </div>
                </div>
                <div class="flex mx-2">
                    <label for="badge-running" class="flex gap-2 items-center cursor-pointer mt-6 w-full">
                        <span class="w-[51px] text-[16px] leading-[20px]" :class="searchSubVariant?'text-[#9E9E9E]':''">New Variant</span>
                        <input v-model="searchSubVariant" :value="true" type="checkbox" id="badge-running" class="hidden peer">
                        <div class="w-12 h-6 bg-theme-green peer-focus:outline-none peer-focus:ring-4 
                        peer-focus:ring-theme-green dark:peer-focus:ring-theme-green relative rounded-full peer 
                        dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
                        after:absolute  after:bg-white after:border-gray-400 after:border after:rounded-full 
                        after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-theme-green"></div>
                        <span :class="!searchSubVariant?'text-[#9E9E9E]':''" class="w-[51px] text-[16px] leading-[20px]">Existing Variant</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="text-sm py-2" v-if="filteredResults?.length>0">This might be a variant of one of these suggestions:</div>
        <div class="text-sm py-2 " v-else>Please search product you would like to merge</div>
        <div class="flex flex-col gap-2 mx-h-96 overflow-hidden px-2">
            <div class="flex items-center" v-for="(filteredResult, ind) in filteredResults" :key="ind">
                <input :id="`noLoc-${filteredResult.id}`" type="radio" v-model="mergeIndex" @change="selectRadio()" :value="filteredResult.id" name="no_reward" class="w-4 h-4  bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <label :for="`noLoc-${filteredResult.id}`" class="ml-2 text-sm font-normal tracking-wider text-white dark:text-gray-300">{{filteredResult.name}} {{ searchSubVariant?`(${filteredResult.variantName})`:'' }}</label>
            </div>
        </div>       
    </div>
</template>
<script>
import {defineComponent} from 'vue'
import {mapGetters} from 'vuex'
import debounce from 'lodash/debounce'
import ProductApi from '@/controllers/BusinessProductApis'
export default defineComponent({
    props: {
        asn: Object,
        placeholder: String,
        selectedIds: Array
    },
    data(){
        return {
            search: '',
            searchSubVariant: false,
            mergeIndex: null,
            results: [],
            filteredResults: [],
        }
    },
    mounted(){
        if(this.vg_complianceType==='aglc'){
            // aglc
            this.search = this.asn?.name?.toLowerCase()
        }else{
            // ocs
            this.search = this.asn?.sku?.toLowerCase()?.split('_')?.shift()
        }
        if(this.search){
            this.payloads = []
            this.searchProduct()
        }
    },
    computed: {
        ...mapGetters({
            vg_locationSelected: "location/selected",
            vg_complianceType: "product/complianceType"
        })
    },
    watch: {
        search: debounce(function(){
            if(this.search){
                this.payloads = []
                this.searchProduct()
            }else{
                this.payloads = []
                this.results = []
            }
        }, 400),
        searchSubVariant(type){           
            this.filterProduct(type)
        }

    },
    methods: {
        async searchProduct(){
            let res = await ProductApi.fetchAllNoLocationProduct(`page=1&pageItem=7&includeCannabis=true&includePricing=true&locationId=${this.vg_locationSelected.id}&search=${this.search}`)
            if(res?.data?.payload?.products){
                if(this.vg_complianceType==='aglc' && this.asn.brandModel?.id){
                    // filter by brand if there are results
                    let tempResults = res.data.payload.products.filter(each => each.brandId===this.asn.brandModel?.id)
                    if(tempResults.length>0){
                        this.results = tempResults
                    }else{
                        // no filter by brand
                        this.results = res.data.payload.products
                    }
                }else{
                    this.results = res.data.payload.products
                }
                this.filterProduct(this.searchSubVariant)
            }
        },
        filterProduct(type){
            this.mergeIndex = null
            this.$emit('select', {type: this.searchSubVariant, productObj:null})
            if(type){
                if(this.selectedIds){
                    this.filteredResults = this.results?.filter(each => !this.selectedIds.includes(parseInt(each.id)))?.slice(0, 8)
                }else{
                    this.filteredResults = this.results?.slice(0, 8)
                }
            }else{
                if(this.selectedIds){
                    this.filteredResults = this.results?.filter(each => each.parentProductId===null && !this.selectedIds.includes(parseInt(each.id)))?.slice(0, 8)
                }else{
                    this.filteredResults = this.results?.filter(each => each.parentProductId===null)?.slice(0, 8)
                }
            }
        },
        selectRadio(){
            let findObj = this.results.find(each => each.id==this.mergeIndex)
            if(findObj){
                this.$emit('select', {type: this.searchSubVariant, productObj:findObj})
            }
        }
    }
})
</script>